module.exports = __webpack_public_path__ + "img/pwa-install-popup-btn.8562c5ea.png";